
import { CampingSite } from '@/services/campingSite/types';

interface InfoWindowEventHandlerProps {
  site: CampingSite;
  onSiteSelect: (siteId: string) => void;
  infoWindow: React.MutableRefObject<google.maps.InfoWindow | null>;
  handleBookNow: (site: CampingSite) => void;
}

export const InfoWindowEventHandler = ({
  site,
  onSiteSelect,
  infoWindow,
  handleBookNow
}: InfoWindowEventHandlerProps) => {
  const attachEventListeners = (attempts = 0) => {
    const maxAttempts = 10;
    
    const bookButton = document.getElementById(`book-site-${site.id}`);
    const closeButton = document.getElementById(`close-site-${site.id}`);
    
    console.log('Attempting to attach event listeners, attempt:', attempts + 1);
    console.log('Book button found:', !!bookButton);
    console.log('Close button found:', !!closeButton);
    
    if (bookButton && closeButton) {
      // Remove any existing event listeners by cloning elements
      const newBookButton = bookButton.cloneNode(true);
      const newCloseButton = closeButton.cloneNode(true);
      
      bookButton.parentNode?.replaceChild(newBookButton, bookButton);
      closeButton.parentNode?.replaceChild(newCloseButton, closeButton);
      
      // Add new event listeners
      newBookButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('Book button clicked successfully for site:', site.id);
        handleBookNow(site);
      });
      
      newCloseButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('Close button clicked for site:', site.id);
        if (infoWindow.current) {
          infoWindow.current.close();
          onSiteSelect('');
        }
      });
      
      console.log('Event listeners attached successfully for site:', site.id);
    } else if (attempts < maxAttempts) {
      console.log('Buttons not found, retrying in 100ms...');
      setTimeout(() => attachEventListeners(attempts + 1), 100);
    } else {
      console.error('Failed to find buttons after', maxAttempts, 'attempts for site:', site.id);
    }
  };

  return { attachEventListeners };
};
